<template>
  <div>
    <div class="btn">
      <!-- 新增 -->
      <el-button type="success" @click="add">{{ $t('message.add') }}</el-button>
      <!-- 保存 -->
      <el-button type="primary" class="primary" @click="tagUpdate">{{ $t('message.save') }}</el-button>
    </div>
    <!-- 商品标签管理 -->
    <div class="table">
      <ol>
        <!-- 仓库类型 -->
        <li>{{ $t('message.warehouseType') }}</li>
        <!-- 商品管理编码 -->
        <li>{{ $t('message.commodityManagementCode') }}</li>
        <!-- 编码格式 -->
        <li>{{ $t('message.encodingFormat') }}</li>
        <!-- 标签编码 -->
        <li>{{ $t('message.tagCoding') }}</li>

        <li>文本信息</li>
        <li>文本信息2</li>
        <li>文本信息3</li>
        <li>文本信息4</li>
        <!-- 下单时使用 -->
        <li>{{ $t('message.usedWhenPlacingAnOrder') }}</li>
        <!-- 文件上传 -->
        <li>{{ $t('message.fileUpload') }}
          <el-tooltip content="只支持上传PDF文件，最好每个标签独立文件" placement="top" effect="light">
            <i class="el-icon-question" style="font-size: 20px;color: #B4272B ;"></i>
          </el-tooltip>

        </li>
        <li class="flex2"> </li>
      </ol>
      <ul v-for="(item, index) in detail.client_product_tag" :key="index">
        <!-- 仓库类型 -->
        <li>
          <el-select v-model="item.type" placeholder="请选择" filterable clearable>
            <el-option v-for="item in tagList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <!-- 商品管理编码 -->
        <li><el-input v-model="item.goods_no" :placeholder="$t('message.commodityManagementCode')"></el-input></li>
        <!-- 标签编码 -->
        <li>
          <el-select v-model="item.code_type" placeholder="请选择">
            <el-option v-for="item in code_type" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <!-- 编码格式 -->
        <li>
          <el-input v-model="item.no"></el-input>
        </li>
        <li><el-input v-model="item.text_line_one"></el-input></li>
        <li><el-input v-model="item.text_line_two"></el-input></li>
        <li><el-input v-model="item.text_line_three"></el-input></li>
        <li><el-input v-model="item.text_line_four"></el-input></li>

        <!-- 下单时使用 -->
        <li>
          <el-checkbox v-model="item.is_order_default"> 使用
          </el-checkbox>
        </li>
        <!-- 文件上传 -->
        <li @click="fileIndex = index">
          <div class="file">
            <a :href="item.pdf_url" target="_blank" rel="noopener noreferrer" class="a-link">{{ item.pdf_name }}</a>
            <!-- 上传 -->
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false" drag :http-request="httpup" accept=".pdf">
              <el-button type="primary">{{ $t('message.upload') }}</el-button>
            </el-upload>
          </div>
        </li>
        <li class="flex2">
          <div>
            <!-- 历史标签 -->
            <el-button type="primary" @click="historyGoodsTag(item.id)">{{ $t('message.historyTag') }}</el-button>
            <!-- 删除 -->
            <el-button type="primary" class="dark" @click="detail.client_product_tag.splice(index, 1)">{{
              $t('message.delete') }}</el-button>
          </div>
        </li>
      </ul>
    </div>
    <!-- 历史标签  -->
    <el-dialog :title="$t('message.historyTag')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1080px" center>
      <div class="content">
        <div class="tabs">
          <el-tabs v-model="datas.type" type="card" @tab-click="handleClick">
            <el-tab-pane label="亚马逊FBA" name="FBA"></el-tab-pane>
            <el-tab-pane label="乐天" name="LETIAN"></el-tab-pane>
            <el-tab-pane label="雅虎" name="YAHU"></el-tab-pane>
            <el-tab-pane label="ZOZO" name="ZOZO"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="table">
          <ol>
            <!-- 商品管理编码 -->
            <li>
              {{ $t("message.commodityManagementCode") }}
            </li>
            <!-- 标签编码 -->
            <li class="flex15">
              {{ $t("message.tagCoding") }}
            </li>
            <li>文本信息</li>
            <li>文本信息2</li>
            <li>文本信息3</li>
            <li>文本信息4</li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <!-- 第一行 -->
          <ul v-for="(item, index) in list" :key="index">
            <!-- 商品管理编码 -->
            <li>
              {{ item.goods_no }}
            </li>
            <!-- 标签编码 -->
            <li class="flex15">
              {{ item.no }}
            </li>
            <li>{{ item.text_line_one }}</li>
            <li>{{ item.text_line_two }}</li>
            <li>{{ item.text_line_three }}</li>
            <li>{{ item.text_line_four }}</li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" @click="choose(item)">{{ $t('message.choose') }}</el-button>
            </li>
          </ul>
          <div style="margin: 30px auto; text-align: center;" v-if="list == false">
            暂无历史标签
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      datas: {
        type: 'FBA'
      },
      detail: {},
      tagList: [
        { label: '亚马逊FBA', value: 'FBA' },
        { label: '乐天', value: 'LETIAN' },
        { label: '雅虎', value: 'YAHU' },
        { label: 'ZOZO', value: 'ZOZO' },
        { label: '其他', value: '其他' },
      ],
      code_type: [{ value: 'CODE128' }, { value: 'EN13' }, { value: 'CODE39' }, { value: 'EN8' }],
      fileIndex: 0

    };
  },
  methods: {
    // 设置数据
    setData(data) {
      data.client_product_tag.forEach(item => {
        item.is_order_default = item.is_order_default ? true : false
      })
      this.detail = data
      console.log(data);

    },
    // 上传
    async httpup(file) {
      let data = await this.createClient(file)
      this.detail.client_product_tag[this.fileIndex].pdf_name = file.file.name
      this.detail.client_product_tag[this.fileIndex].pdf_url = data.data
      this.$forceUpdate()
    },
    // 新增
    add() {
      this.detail.client_product_tag.push({
        code_type: "CODE128",
        goods_no: "",
        is_order_default: true,
        no: '',
        pdf_name: '',
        pdf_url: '',
        text_line_four: '',
        text_line_one: '',
        text_line_three: '',
        text_line_two: '',
        type: '',
        type_translate: '',
      })
    },
    //信息维护-数据维护-标签设置
    tagUpdate() {
      let list = []
      this.detail.client_product_tag.forEach(item => {
        let itemData = JSON.parse(JSON.stringify(item))
        itemData.is_order_default = itemData.is_order_default ? 1 : 0
        itemData.type_translate = itemData.type
        list.push(itemData)
      })
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        list,
      }
      this.$api.productManagementApi.tagUpdate(datas)
    },
    //切换type
    handleClick() {
      this.list = this.historyTagList.filter(item => item.type == this.datas.type)
    },
    // 历史标签
    historyGoodsTag() {
      let datas = {
        sys_code: this.detail.sys_code,
      }
      this.$api.productManagementApi.historyGoodsTag(datas).then((res) => {
        this.historyTagList = res.data
        this.dialogVisible = true
        this.handleClick()

      })
    },
    //选择
    choose(item) {
      item.is_order_default = true
      this.detail.client_product_tag.push(item)
      this.dialogVisible = false
    },
  }
}
</script>
<style lang='scss' scoped>
.btn {
  text-align: right;
  margin-bottom: 24px;
}

.table {
  li {

    padding: 0 10px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex2 {
    flex: 1.5;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 56px;
  }

  ul {
    background-color: #fff;
    height: 130px;
    padding: 5px 0;


    .file {
      display: flex;

      a {
        margin-right: 20px;
      }

      /deep/.el-upload-dragger {
        width: auto;
        height: auto;
        border: none;
      }
    }
  }


}
</style>